import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import { API_BASE_URL } from "../../../../../Helpers/apiConfig";

const SingleEducationalForm = ({ educational, courses, allsubjects, userId, userToken, t, toPlainOptionLabel }) => {
    const [localCourseId, setLocalCourseId] = useState(String(educational.courseId || ""));
    const [localSubjectId, setLocalSubjectId] = useState(String(educational.subjectId || ""));
    // localContentId kullanılmıyorsa silebilirsin, şimdilik orijinal koddaki gibi bıraktım
    const [localContentId, setLocalContentId] = useState(String(educational.contentId || ""));
    const [contents, setContents] = useState([]);

    const [localSubjects, setLocalSubjects] = useState([]);
    const [localSubjectLoading, setLocalSubjectLoading] = useState(false);

    const getAuthHeaders = () => ({
        "accept": "*/*",
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': 'false',
        'Authorization': 'Bearer ' + userToken
    });

    const fetchLocalSubjects = async (courseId) => {
        if (!courseId) {
            setLocalSubjects([]);
            return;
        }
        try {
            setLocalSubjectLoading(true);
            const res = await axios({
                method: 'GET',
                url: `${API_BASE_URL}/admin/SubjectManager/GetListByCourse`,
                headers: getAuthHeaders(),
                params: { id: courseId }
            });
            if (res.status === 200 && res.data['success']) {
                setLocalSubjects((res.data?.data || []).filter((item) => item?.isActive));
            } else {
                setLocalSubjects([]);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLocalSubjectLoading(false);
        }
    };

    useEffect(() => {
        if (localCourseId) {
            fetchLocalSubjects(localCourseId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleCourseChange = async (e) => {
        const courseId = e.target.value;
        setLocalCourseId(courseId);
        setLocalSubjectId("");
        await fetchLocalSubjects(courseId);
    };
    const handleSubjectChange = async (e) => {
        setLocalSubjectId(e.target.value);
        const res = await axios({
            method: 'GET',
            url: `${API_BASE_URL}/admin/ContentManager/GetListBySubject`,
            headers: getAuthHeaders(),
            params: { subjectId: e.target.value }
        });
        if (res.status === 200 && res.data['success']) {
            setContents((res.data?.data));
        } else {
            setContents([]);
        }
    };
    const handleLocalSubmit = async (e) => {
        e.preventDefault();

        let CourseId = 0;
        let SubjectId = 0;
        courses.forEach((item) => {
            if (item['id'] === parseInt(localCourseId)) {
                CourseId = item.id;
            }
        });

        allsubjects.forEach((item) => {
            if (item['id'] === parseInt(localSubjectId)) {
                SubjectId = item.id;
            }
        });
        const data = {
            userId: parseInt(userId),
            courseId: CourseId,
            subjectId: SubjectId,
            contentId: parseInt(localContentId) || 1
        };
        try {
            let url = `${API_BASE_URL}/admin/User/UpdateEducational`;
            await axios({
                method: 'PUT',
                url: url,
                data: data,
                headers: getAuthHeaders()
            }).then(res => {
                if (res.status === 200) {
                    if (res.data['success']) {
                        Swal.fire({
                            title: "Başarılı!",
                            icon: "success",
                            confirmButtonText: `Tamam`,
                            timer: 3000,
                        }).then(() => {
                            window.location.reload();
                        })
                    } else {
                        Swal.fire({
                            title: res.data['message'],
                            icon: "error",
                            timer: 3000,
                            confirmButtonText: `Tamam`
                        }).then(() => {
                            window.location.reload();
                        });
                    }
                } else {
                    Swal.fire({
                        title: "Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.",
                        icon: "error",
                        confirmButtonText: "Tamam"
                    });
                }
            });
        } catch (err) {
            Swal.fire({
                title: err.message,
                icon: "error",
                confirmButtonText: "Tamam"
            });
        }
    };

    const handleRemove = async () => {
        const confirmResult = await Swal.fire({
            title: "Bu kursu kaldırmak istediğinize emin misiniz?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Evet, Kaldır",
            cancelButtonText: "Vazgeç"
        });
        if (!confirmResult.isConfirmed) return;

        try {
            const res = await axios({
                method: 'POST',
                url: `${API_BASE_URL}/admin/User/RemoveUserCourse`,
                data: {
                    userId: parseInt(userId),
                    courseId: educational.courseId
                },
                headers: getAuthHeaders()
            });
            if (res.status === 200 && res.data['success']) {
                Swal.fire({
                    title: "Kaldırıldı!",
                    icon: "success",
                    confirmButtonText: "Tamam",
                    timer: 3000
                }).then(() => {
                    window.location.reload();
                });
            } else {
                Swal.fire({
                    title: res.data['message'] || "Kaldırma başarısız.",
                    icon: "error",
                    confirmButtonText: "Tamam"
                });
            }
        } catch (err) {
            Swal.fire({
                title: err.message,
                icon: "error",
                confirmButtonText: "Tamam"
            });
        }
    };

    return (
        <form onSubmit={handleLocalSubmit} className="border p-4 mb-4 rounded bg-light shadow-sm">
            <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                <h6 className="text-primary mb-0">Eğitim Kayıt ID: {educational.id}</h6>
                <button type="button" className="btn btn-outline-danger btn-sm" onClick={handleRemove}>
                    Kaldır
                </button>
            </div>

            <div className="mb-3">
                <label className="form-label">{t("selectCourse")}</label>
                <select className="form-select" onChange={handleCourseChange} value={localCourseId}>
                    <option value="">{t("selectCourse")}</option>
                    {courses ? (
                        courses.map((dt) => (
                            <option key={dt.id} value={dt.id}>
                                {toPlainOptionLabel(`${dt.courseName} - ${dt.courseDesc}`)}
                            </option>
                        ))
                    ) : (
                        <option value="">{t("reloadWarning")}</option>
                    )}
                </select>
            </div>

            <div className="mb-3">
                <label className="form-label">{t("selectSubject")}</label>
                <select
                    className="form-select"
                    onChange={handleSubjectChange}
                    value={localSubjectId}
                    disabled={!localCourseId || localSubjectLoading}
                >
                    <option value="">{t("selectSubject")}</option>
                    {localSubjects ? (
                        localSubjects.map((dt) => (
                            <option key={dt.id} value={dt.id}>
                                {toPlainOptionLabel(`${dt.subjectName} - ${dt.subjectDesc}`)}
                            </option>
                        ))
                    ) : (
                        <option value="">{t("reloadWarning")}</option>
                    )}
                </select>
            </div>
            <div className="mb-3">
                <label className="form-label">Soru Seç</label> <i>Aktif soru Sıralama id. Bölüm hiç çözülmediyse 1 yazılabilir. örneğin 10.uncu sorudaysa soru sıralama id +1 olarak 11 yazar. Örneğin öğrenci en son 10.uncu soruyu çözdü devam edemiyorsa buraya gelip 11 olarak düzeltebilirsiniz.</i>


                <select
                    className="form-select"
                    onChange={(e) => setLocalContentId(e.target.value)}
                    value={localContentId}
                    disabled={!localSubjectId}>
                    <option value="">soru seçiniz</option>
                    {contents ? (
                        contents.map((dt) => (
                            <option key={dt.id} value={dt.sortId}>
                                {dt.sortId}
                            </option>
                        ))
                    ) : (
                        <option value="">{t("reloadWarning")}</option>
                    )}
                </select>

            </div>
            <div className='d-flex justify-content-end'>
                <button type="submit" className="btn btn-primary" disabled={!localCourseId || !localSubjectId}>
                    {t("update")}
                </button>
            </div>
        </form>
    );
};

export default SingleEducationalForm;